import { removeAccount } from 'containers/Login/loginSlice'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import { useReduxDispatch } from 'store'
import React, { useState } from 'react'

const DeleteAccount: React.FC = () => {
  const [isLoading, setLoading] = useState(false)

  const { replace } = useHistory()
  const dispatch = useReduxDispatch()
  const { t } = useTranslation('account')
  const removeAccountAction = async () => {
    setLoading(true)
    dispatch(removeAccount()).then(res => {
      if (res.meta.requestStatus === 'fulfilled') {
        replace('/')
      } else {
        setLoading(false)
      }
    })
  }

  return (
    <Popup>
      <div className='deleteAccount'>
        <div className='popup__title'>
          <div>{t('areYouSure')}</div>
          <div>{t('accountDeletionIsIrreversible')}</div>
        </div>
        <div className='popup__buttons'>
          <ArrowBtn
            enlarged
            className='--red'
            isLoading={isLoading}
            text={t('confirmAccountDeletion')}
            action={removeAccountAction}
          />
          <BackBtn text={t('cancel')} />
        </div>
      </div>
    </Popup>
  )
}

export default DeleteAccount